import { createAction } from '@reduxjs/toolkit'

import { TCommentApi } from 'types/GlobalComment'

// tryGetAllComments
export const getAll = createAction<string>('get_all_comments')
export const getAllSuccess = createAction<{
  data: TCommentApi[]
  keyMetricId?: string
  reportEditionId?: string
  analysisId?: string
}>('get_all_comments_success')
export const getAllFailed = createAction('get_all_comments_failed')

// tryCreateComment
export const create = createAction('create_comment')
export const createSuccess = createAction<{ data: TCommentApi }>(
  'create_comment_success'
)
export const createFailed = createAction('create_comment_failed')

// tryUpdateComment
export const update = createAction('update_comment')
export const updateSuccess = createAction<{ data: TCommentApi }>(
  'update_comment_success'
)
export const updateFailed = createAction('update_comment_failed')

// tryDeleteComment
export const destroy = createAction('delete_comment')
export const destroySuccess = createAction<string>('delete_comment_success')
export const destroyFailed = createAction('delete_comment_failed')
